<template>
  <div class="edit-gen-page" v-loading="loading">
    <!-- 顶部 Header -->
    <div class="page-header">
      <div class="header-left">
        <el-button icon="el-icon-arrow-left" size="small" circle @click="$router.go(-1)"></el-button>
        <span class="page-title">{{ id ? '编辑数字通证' : '新增数字通证' }}</span>
        <el-tag v-if="Form.tokenName" size="small" type="info" effect="plain" class="title-tag">
          {{ Form.tokenName }}
          <span v-if="Form.tokenNum" class="token-num">#{{ Form.tokenNum }}</span>
        </el-tag>
      </div>
    </div>

    <el-form :model="Form" :rules="rules" ref="ruleForm" label-width="140px" class="edit-form">
      <!-- 账户信息 -->
      <el-card class="form-card" shadow="never">
        <div slot="header" class="card-header">
          <i class="el-icon-user-solid"></i>
          <span>账户信息</span>
        </div>
        <el-row :gutter="32">
          <el-col :xl="12" :lg="12" :md="12" :sm="24">
            <el-form-item label="登录账户：" prop="account">
              <el-input v-model="Form.account" placeholder="请输入登录账户"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="12" :lg="12" :md="12" :sm="24">
            <el-form-item label="登录密码：" prop="pwd">
              <el-input v-model="Form.pwd" placeholder="请输入登录密码"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="归集账户地址：" prop="wallet">
              <el-input v-model="Form.wallet" placeholder="请输入归集账户地址"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <!-- 通证基本信息 -->
      <el-card class="form-card" shadow="never">
        <div slot="header" class="card-header">
          <i class="el-icon-document"></i>
          <span>通证基本信息</span>
        </div>
        <el-row :gutter="32">
          <el-col :xl="12" :lg="12" :md="12" :sm="24">
            <el-form-item label="数字通证名称：" prop="tokenName">
              <el-input v-model="Form.tokenName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="12" :lg="12" :md="12" :sm="24">
            <el-form-item label="数字通证英文名称：" prop="tokenEnglish">
              <el-input v-model="Form.tokenEnglish"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="12" :lg="12" :md="12" :sm="24">
            <el-form-item label="数字通证编号：" prop="tokenNum">
              <el-input v-model="Form.tokenNum"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="12" :lg="12" :md="12" :sm="24">
            <el-form-item label="开发者：" prop="developer">
              <el-input v-model="Form.developer"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="12" :lg="12" :md="12" :sm="24">
            <el-form-item label="核心算法：" prop="coreAlgorithm">
              <el-input v-model="Form.coreAlgorithm"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="12" :lg="12" :md="12" :sm="24">
            <el-form-item label="总量：" prop="gross">
              <el-input v-model="Form.gross"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="12" :lg="12" :md="12" :sm="24">
            <el-form-item label="发行日期：" prop="issuingDate">
              <el-date-picker v-model="Form.issuingDate" type="datetime" placeholder="选择日期时间"
                style="width: 100%" value-format="timestamp">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xl="12" :lg="12" :md="12" :sm="24">
            <el-form-item label="公钥：" prop="secret">
              <el-input v-model="Form.secret"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="通证图片：">
              <el-upload class="avatar-uploader" action="" :show-file-list="false" :on-success="handleAvatarSuccess"
                :http-request="mainPicUpload">
                <img v-if="Form.image" :src="Form.image" class="avatar" />
                <div v-else class="avatar-uploader-icon">
                  <i class="el-icon-plus"></i>
                  <div class="upload-tip">点击上传</div>
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <!-- 价格与划拨 -->
      <el-card class="form-card" shadow="never">
        <div slot="header" class="card-header">
          <i class="el-icon-price-tag"></i>
          <span>价格与划拨配置</span>
        </div>
        <el-row :gutter="32">
          <el-col :xl="12" :lg="12" :md="12" :sm="24">
            <el-form-item label="协议区价格：" prop="agreementPrice">
              <el-input v-model="Form.agreementPrice"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="12" :lg="12" :md="12" :sm="24">
            <el-form-item label="原价区价格：" prop="price">
              <el-input v-model="Form.price"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="12" :lg="12" :md="12" :sm="24">
            <el-form-item label="扣除差价百分比：" prop="rate">
              <el-input v-model="Form.rate"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="12" :lg="12" :md="12" :sm="24">
            <el-form-item label="涨跌幅比例：" prop="closePriceRate">
              <el-input v-model="Form.closePriceRate"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="12" :lg="12" :md="12" :sm="24">
            <el-form-item label="划拨折扣：" prop="agreementRate">
              <el-input v-model="Form.agreementRate"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="12" :lg="12" :md="12" :sm="24">
            <el-form-item label="商城流入百分比：" prop="shopRate">
              <el-input v-model="Form.shopRate"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="12" :lg="12" :md="12" :sm="24" v-if="id == 3">
            <el-form-item label="划拨CND比例：">
              <el-input v-model="Form.transferCnyRate"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="12" :lg="12" :md="12" :sm="24" v-if="id == 2">
            <el-form-item label="拆分增量额CNY抵扣价：">
              <el-input v-model="Form.exchangePrice"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <!-- 时间与锁仓 -->
      <el-card class="form-card" shadow="never">
        <div slot="header" class="card-header">
          <i class="el-icon-time"></i>
          <span>时间与锁仓配置</span>
        </div>
        <el-row :gutter="32">
          <el-col :xl="12" :lg="12" :md="12" :sm="24">
            <el-form-item label="通证转出时间：" prop="transferTime">
              <el-input v-model="Form.transferTime" placeholder="格式：09:00:00-17:00:00"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="12" :lg="12" :md="12" :sm="24">
            <el-form-item label="划拨确认时间：" prop="affirmTime">
              <el-input v-model="Form.affirmTime" placeholder="格式：09:00:00-17:00:00"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="12" :lg="12" :md="12" :sm="24">
            <el-form-item label="退回钱包天数：" prop="backTime">
              <el-input v-model="Form.backTime"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="12" :lg="12" :md="12" :sm="24">
            <el-form-item label="区块时间：" prop="blocksTime">
              <el-input v-model="Form.blocksTime"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="12" :lg="12" :md="12" :sm="24">
            <el-form-item label="锁仓天数：" prop="rockTime">
              <el-input v-model="Form.rockTime"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="12" :lg="12" :md="12" :sm="24">
            <el-form-item label="开盘时间：" prop="rockTime">
              <el-input v-model="Form.openTime" placeholder="格式：09:00:00-11:30:00,13:00:00-15:00:00"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <!-- 其他配置 -->
      <el-card class="form-card" shadow="never">
        <div slot="header" class="card-header">
          <i class="el-icon-setting"></i>
          <span>其他配置</span>
        </div>
        <el-row :gutter="32">
          <el-col :span="24">
            <el-form-item label="商场CNY通知地址：" prop="cnyUrl">
              <el-input v-model="Form.cnyUrl"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xl="12" :lg="12" :md="12" :sm="24">
            <el-form-item label="开盘状态：" prop="openStatus">
              <el-radio-group v-model="Form.openStatus">
                <el-radio :label="1">开盘</el-radio>
                <el-radio :label="2">不开盘</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :xl="12" :lg="12" :md="12" :sm="24">
            <el-form-item label="状态：" prop="status">
              <el-radio-group v-model="Form.status">
                <el-radio :label="0">上线</el-radio>
                <el-radio :label="1">下线</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>
    </el-form>

    <!-- 底部操作栏 -->
    <div class="form-footer">
      <el-button @click="$router.go(-1)">取消</el-button>
      <el-button type="primary" :loading="loading" @click="submit()">提交保存</el-button>
    </div>
  </div>
</template>

<script>
import uploadImage from '../../utils/ossutil/uploadFile';
export default {
  data() {
    return {
      Form: {},
      rules: {},
      loading: false,
      id: "",
      imageUrl: {}
    };
  },
  mounted() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.getInfo();
    }
  },
  methods: {
    getInfo() {
      this.axios.get("/admin/gen/findById", { id: this.id }).then((res) => {
        this.Form = res.data.data;
      });
    },
    submit() {
      this.loading = true;
      if (this.id) {
        this.axios.put("/admin/gen/updateGen", this.Form).then((res) => {
          this.loading = false;
          if (res.code == 200) {
            this.$router.push("gen");
          } else {
            this.$message(res.mesg);
          }
        });
      } else {
        this.axios.post("/admin/gen/addGen", this.Form).then((res) => {
          this.loading = false;
          if (res.data.code == 200) {
            this.$router.push("gen");
          } else {
            this.$message(res.data.mesg);
          }
        });
      }
    },
    // 上传图片
    mainPicUpload(options) {
      this.loading = true
      function dataUrl(data) {
        let arr = data.split('&')
        let list = {}
        arr.forEach(item => {
          let itm = item.split('=')
          list[itm[0]] = decodeURIComponent(itm[1])
        })
        return list
      }
      var { file } = options
      uploadImage(file, 'images/',
        result => {
          this.Form.image = result
          this.loading = false
        }
      )
      return
      let data
      this.axios.get('/getOSSKey', {}).then(res => {
        data = res.data.data
        var ossData = new FormData()
        ossData.append('name', file.name)
        let filename = `${Date.parse(new Date())}` + file.name //图片名称
        let keyValue = data.dir + filename
        //请求数据
        ossData.append('key', keyValue)
        ossData.append('callback', data.callback)
        ossData.append('policy', data.policy)
        ossData.append('OSSAccessKeyId', data.accessid)
        ossData.append('success_action_status', 200)
        ossData.append('signature', data.signature)
        ossData.append('file', file)
        this.axios.post(data.host, ossData).then(res => {
          this.imageUrl = dataUrl(res.data.Status)
          this.imageUrl = this.imageUrl.filename
          this.Form.image = this.imageUrl
          this.loading = false
        })
      })
    },

    handleAvatarSuccess(res, file) {
      console.log(res, file)
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-gen-page {
  padding: 20px 24px 100px;
  background-color: #f5f7fa;
  min-height: calc(100vh - 60px);
  box-sizing: border-box;
}

/* 顶部 Header */
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 16px 24px;
  border-radius: 8px;
  margin-bottom: 16px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}

.header-left {
  display: flex;
  align-items: center;
}

.page-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin-left: 12px;
  position: relative;
  padding-left: 12px;
}

.page-title::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 16px;
  background: #409eff;
  border-radius: 2px;
}

.title-tag {
  margin-left: 16px;

  .token-num {
    margin-left: 6px;
    color: #909399;
  }
}

/* 表单卡片 */
.form-card {
  margin-bottom: 16px;
  border-radius: 8px;
  border: 1px solid #ebeef5;
  transition: box-shadow 0.2s ease;
}

.form-card:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.06);
}

.form-card ::v-deep .el-card__header {
  padding: 14px 20px;
  background: #fafbfc;
  border-bottom: 1px solid #ebeef5;
}

.form-card ::v-deep .el-card__body {
  padding: 24px 20px 8px;
}

.card-header {
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: 600;
  color: #303133;

  i {
    margin-right: 8px;
    color: #409eff;
    font-size: 16px;
  }
}

/* 表单项 */
.edit-form ::v-deep .el-form-item {
  margin-bottom: 22px;
}

.edit-form ::v-deep .el-form-item__label {
  color: #606266;
  font-weight: 500;
}

.edit-form ::v-deep .el-input__inner:focus,
.edit-form ::v-deep .el-input__inner:hover {
  border-color: #409eff;
}

/* 上传图片 */
.avatar-uploader ::v-deep .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: border-color 0.3s;
  display: inline-block;
}

.avatar-uploader ::v-deep .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  width: 120px;
  height: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #8c939d;
  background: #fafbfc;

  i {
    font-size: 28px;
  }

  .upload-tip {
    margin-top: 6px;
    font-size: 12px;
    color: #909399;
  }
}

.avatar {
  width: 120px;
  height: 120px;
  display: block;
  border-radius: 6px;
  object-fit: cover;
}

/* 底部 footer */
.form-footer {
  position: fixed;
  bottom: 0;
  left: 200px;
  right: 0;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  background: #fff;
  padding: 14px 32px;
  border-top: 1px solid #ebeef5;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.04);
  z-index: 10;

  .el-button {
    min-width: 100px;
  }

  .el-button + .el-button {
    margin-left: 8px;
  }
}

/* 兼容侧边栏收起时的情况 */
@media (max-width: 768px) {
  .form-footer {
    left: 0;
  }
}
</style>
